import {
  GetPriceTrendsDataWithCustomerGroupsQuery,
  GetPriceTrendsDataWithCustomerGroupsQueryVariables,
} from '@/types';
import { gql } from '@apollo/client';
import { useWrappedQuery } from './use-wrapped-query';

export const PRICE_TRENDS_QUERY = gql`
  query getPriceTrendsDataWithCustomerGroups(
    $supplierUUID: uuid!
    $variantPackUUID: uuid!
    $restaurantGroupUUIDs: [uuid!]!
  ) {
    getPriceTrendsDataWithCustomerGroups(
      supplier_id: $supplierUUID
      variant_pack_id: $variantPackUUID
      restaurant_group_ids: $restaurantGroupUUIDs
    ) {
      median_price_l7
      median_price_l30
      median_price_l90
      median_price_yoy
      median_gp_l7
      median_gp_l30
      median_gp_l90
      median_gp_yoy
      gp_occurrences_l7 {
        occurrences
        gross_profit
      }
      gp_occurrences_l30 {
        occurrences
        gross_profit
      }
      gp_occurrences_l90 {
        occurrences
        gross_profit
      }
      gp_occurrences_yoy {
        occurrences
        gross_profit
      }
      price_occurrences_l7 {
        price
        occurrences
      }
      price_occurrences_l30 {
        occurrences
        price
      }
      price_occurrences_l90 {
        occurrences
        price
      }
      price_occurrences_yoy {
        occurrences
        price
      }
      last_price_yoy
      last_gp_yoy
    }
  }
`;

export const useGetPriceTrends = (
  supplierUUID: string,
  variantPackUUID: string,
  restaurantGroupUUIDs: string[],
) => {
  const { data, loading } = useWrappedQuery<
    GetPriceTrendsDataWithCustomerGroupsQuery,
    GetPriceTrendsDataWithCustomerGroupsQueryVariables
  >(PRICE_TRENDS_QUERY, {
    context: {
      noBatch: true,
    },
    skip: !variantPackUUID || !supplierUUID,
    variables: {
      restaurantGroupUUIDs,
      supplierUUID: supplierUUID,
      variantPackUUID: variantPackUUID,
    },
  });

  const priceTrendsData = data?.getPriceTrendsDataWithCustomerGroups;
  const lastGP = priceTrendsData?.last_gp_yoy ?? null;
  const lastPrice = priceTrendsData?.last_price_yoy ?? null;

  return {
    lastGP,
    lastPrice,
    loading,
    priceTrendsData,
  };
};
